module.exports = __webpack_public_path__ + "img/gps_and_kakao.dd5e39ee.jpg";